module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEfSURBVHgB7ZPBTQMxEEX/rLhxICWEE0TisOlgO4gJDZAKgAoIFUAaSUwF2VSAb0u4kBJyQpEQY74DQQQco4UTiH9Y2V7N858ZD/B7ZW4a+IYkCpLtEcQX3M2gj4ewBw61geaejhYGWdbhLofibAkV6UD1Io1ZWNj2PKy23h02CDvnIqRawu5ZmIpu5eT1PKGdMT/zdYdvTquCgDG8lHSYAzrAsNXHj2SqJrpVH2Zq4v83N0xQ66K7HJkP6QWghT70VrX7DFw1JaWXWpZQGRA8YjjXT5OvmpJSkzWdwLYcjqYO3odXUaSbklL39pQhl/BwjOTT0l3CZ2tJbAyOFX64f0VID6LXTLv9ERZ3+D8pdScl3uUwKRmOoZlbOv1Tegbx6IZgkbdLLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpclit2.png
// module id = YFd4
// module chunks = 0